import { NAVBAR_ROUTES } from "./routeAccessPolicy.mjs";

export const FIRM_MANAGEMENT_TABS = [
  { id: "directory", label: "Directory" },
  { id: "case-merge", label: "Case Merge" },
  { id: "client-merge", label: "Client Merge" },
  { id: "templates", label: "Templates" },
  { id: "electronic-signature", label: "Electronic Signature" },
  { id: "auto-tasks", label: "Auto Tasks" },
];

export const MOVED_FIRM_SETTINGS_TABS = {
  "client-merge": "client-merge",
  templates: "templates",
  "e-signature": "electronic-signature",
  "auto-tasks": "auto-tasks",
};

export const getFirmManagementUrl = (clientId, caseId, tabId) =>
  clientId && caseId
    ? `/${NAVBAR_ROUTES.directory}/${encodeURIComponent(clientId)}/${encodeURIComponent(caseId)}?tab_id=${encodeURIComponent(tabId)}`
    : "/search/";
